import Logo from "images/LOGO.svg";
import IconWeather from "images/icon-weather.svg";
import IconCityInfo from "images/icon-cityInfo-button.svg";
import IconCityInfoActive from "images/icon-cityInfo-button-active.svg";
import IconMenu from "images/icon-menu.svg";
import IconClose from "images/icon-close.svg";

import { Link } from "react-router-dom";
import classNames from "classnames";
import Avatar from "./Avatar";
import { useWeatherForecastQuery } from "services/api";
import CityInfo from "features/forestage/CityInfo";

interface BaseHeaderProps {
  showCityInfo: boolean;
  showSideNav: boolean;
  setShowCityInfo: (value: boolean) => void;
  setShowSideNav: (value: boolean) => void;
}

const BaseHeader = ({
  showCityInfo,
  showSideNav,
  setShowCityInfo,
  setShowSideNav,
}: BaseHeaderProps) => {
  const { data: weather } = useWeatherForecastQuery();

  return (
    <header className="sticky top-0 left-0 z-20 flex w-full min-w-[375px] justify-between bg-grandma-400 p-3 text-white print:hidden md:pl-6 md:pr-5 lg:mr-9">
      <h1>
        <Link to="/" className="md:flex md:h-full md:items-center">
          <img
            src={Logo}
            className="h-[43px] w-[222px] lg:h-[68px] lg:w-[336px]"
            alt="台南城市儀表板"
            draggable="false"
          />
        </Link>
      </h1>
      <div className="flex flex-auto items-center justify-end">
        {weather && (
          <div className="hidden items-end md:flex md:flex-auto md:justify-end">
            <div className="h-10 lg:h-[60px] lg:w-[60px]">
              <img
                className="w-full"
                src={IconWeather}
                alt="氣溫"
                draggable="false"
              />
            </div>

            <p className="ml-2 text-2xl font-medium leading-9 tracking-tighter md:mr-5 lg:mr-9">
              {weather.maxT}
              <small className="pl-1 pt-1 align-top text-2xl">°</small>
            </p>
          </div>
        )}

        <div
          className={classNames(
            "mr-5 h-10 w-11 cursor-pointer md:block lg:h-[60px] lg:w-[60px]",
            {
              hidden: showSideNav,
            }
          )}
          onClick={() => {
            setShowCityInfo(!showCityInfo);
          }}
        >
          {showCityInfo ? (
            <img
              className="w-full"
              src={IconCityInfoActive}
              alt="icon"
              draggable="false"
            />
          ) : (
            <img
              className="w-full"
              src={IconCityInfo}
              alt="icon"
              draggable="false"
            />
          )}
        </div>

        {showCityInfo && <CityInfo onClose={() => setShowCityInfo(false)} />}

        <div
          className="cursor-pointer md:hidden"
          onClick={() => {
            setShowSideNav(!showSideNav);
            setShowCityInfo(false);
          }}
        >
          {showSideNav ? (
            <img
              className="h-9 w-9"
              src={IconClose}
              alt="close"
              draggable="false"
            />
          ) : (
            <img
              className="h-9 w-9"
              src={IconMenu}
              alt="menu"
              draggable="false"
            />
          )}
        </div>

        <div className="relative hidden border-l border-gray-700 border-opacity-20 md:block md:pl-5 lg:pl-7">
          <Avatar />
        </div>
      </div>
    </header>
  );
};

export default BaseHeader;
